import React from "react";
import { Link } from "react-router-dom";
import Seo from "./Seo";
function ButtonLink({ children, to, secondary = false, accent = false, basic = false, basicLight = false, className = "" }) {
    const buttonStyle = secondary
        ? (basic ? (basicLight ? "border border-[#fa7223] text-[#2b2a29] hover:bg-[#fa7223] hover:text-white" : "border border-[#fa7223] text-white hover:bg-[#fa7223] hover:text-white") : "border border-[#071D2B] text-[#071D2B] hover:bg-[#071D2B] hover:text-white")
        : basic
            ? "bg-[#fa7223] text-white hover:bg-[#e45c12]"
            : accent
                ? "bg-[#F36C21] text-white hover:bg-[#D95712]"
                : "bg-[#31BF5C] text-white hover:bg-[#269c49]";

    return <Link to={to} className={"inline-flex min-h-[48px] items-center justify-center rounded-full px-6 py-3 text-sm font-semibold transition " + buttonStyle + " " + className}>{children}</Link>;
}


function MarketingLayout({ children, title, description, path, theme = "" }) {
    return <><Seo title={title} description={description} path={path} /><main className={"w-full text-[#071D2B] " + theme}><div className="mx-auto w-full max-w-[1180px] px-5 py-12 sm:px-8 lg:py-16">{children}</div></main></>;
}

export { ButtonLink };
export default MarketingLayout;

